import { render, staticRenderFns } from "./EditFeeType.vue?vue&type=template&id=04df5154&scoped=true"
import script from "./EditFeeType.vue?vue&type=script&lang=js"
export * from "./EditFeeType.vue?vue&type=script&lang=js"
import style0 from "./EditFeeType.vue?vue&type=style&index=0&id=04df5154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df5154",
  null
  
)

export default component.exports